import React from 'react'
import { useSelector } from 'react-redux'

import { LightThemeProvider } from '@qflow/theme'

import { Alerts } from 'portal/components/Alerts'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'

import { selectGlobalDate } from 'portal/store/global/selectors'

const globalDateSelector = selectGlobalDate()

export const AlertsPage = ({ alertsType }: { alertsType: string }) => {
  const { startDate, endDate } = useSelector(globalDateSelector)

  return (
    <LightThemeProvider>
      <Sidebar />
      <PageContainer>
        <Alerts
          startDate={startDate}
          endDate={endDate}
          alertsType={alertsType}
        />
      </PageContainer>
    </LightThemeProvider>
  )
}
